import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDlnaComponent } from './simple-icons-dlna.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDlnaComponent ],
    exports:      [ SimpleIconsDlnaComponent ],
    bootstrap:    []
})
export class SimpleIconsDlnaModule {}
